import "./AdminTopbar.css";

const AdminTopbar = ({ title, subtitle, actionLabel, onAction, secondaryActionLabel, onSecondaryAction }) => {
    return (
        <header className="admin-topbar">
            <div>
                <p>Panel administrativo</p>
                <h1>{title}</h1>
                <span>{subtitle}</span>
            </div>

            <div style={{ display: "flex", gap: "1rem" }}>
                {secondaryActionLabel && (
                    <button className="admin-topbar__action" type="button" onClick={onSecondaryAction}>
                        {secondaryActionLabel}
                    </button>
                )}
                {actionLabel && (
                    <button className="admin-topbar__action" type="button" onClick={onAction}>
                        {actionLabel}
                    </button>
                )}
            </div>
        </header>
    );
};

export default AdminTopbar;